import { SwitchSimple } from 'src/v2/commonComponents/SwitchSimple';
import { SettingKeys, ToggleSetting } from 'src/types/settings';
import { useUserSettings, useUserSettingsUpdate } from 'src/hooks';

interface SettingsSwitchProps {
  settingKey: SettingKeys;
}

export const SettingsSwitch = ({
  settingKey,
  ...rest
}: SettingsSwitchProps) => {
  const { setting } = useUserSettings<ToggleSetting>(settingKey);

  const { updateUserSetting } = useUserSettingsUpdate();

  const handleChange = (value: boolean) => {
    updateUserSetting({ value, settingKey });
  };

  return (
    <SwitchSimple
      isDisabled={
        !setting?.user_editable || !setting?.options['true'].selectable
      }
      isChecked={!!setting?.value}
      onChange={handleChange}
      {...rest}
    />
  );
};
